import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import { isPushSupported, getCurrentSubscription, subscribePush, unsubscribePush, sendTestPush } from "@/lib/push";

export default function PushToggle() {
  const [supported, setSupported] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  const refresh = async () => {
    const s = await isPushSupported();
    setSupported(s);
    if (s) {
      const sub = await getCurrentSubscription();
      setSubscribed(!!sub && Notification.permission === "granted");
    }
  };

  useEffect(() => { refresh(); }, []);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (subscribed) {
        await unsubscribePush();
        toast.success("Notificaciones desactivadas");
        setSubscribed(false);
      } else {
        await subscribePush();
        toast.success("Notificaciones activadas");
        setSubscribed(true);
        // Send a confirmation push so the user sees it works
        try { await sendTestPush(); } catch { /* ignore */ }
      }
    } catch (err) {
      toast.error(err.message || "No se pudo activar notificaciones");
    } finally {
      setBusy(false);
    }
  };

  const Icon = !supported ? BellOff : subscribed ? BellRing : Bell;
  const tone = subscribed
    ? { color: "var(--cyan)", label: "Push ON", glow: "0 0 8px var(--cyan-glow)" }
    : { color: "var(--text-dim)", label: "Push OFF", glow: "none" };

  return (
    <button
      data-testid="push-toggle-btn"
      onClick={toggle}
      disabled={busy}
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[10px] font-semibold uppercase tracking-widest hover:bg-white/5 transition-colors disabled:opacity-50"
      style={{ border: "1px solid var(--border-2)", color: tone.color, textShadow: tone.glow }}
      title={subscribed ? "Recibir alertas en tu dispositivo" : "Activar notificaciones push"}
    >
      <Icon className="w-3.5 h-3.5" />
      <span className="hidden sm:inline">{tone.label}</span>
    </button>
  );
}
